export const subPermissionKeys = {
  groupKey: 'agreement',

  read: 'agreement-listar-convenios',
  create: 'agreement-crear-convenio',
  edit: 'agreement-actualizar-convenio',
  delete: '',
};
